import PropTypes from 'prop-types'
import * as S from './style'
import loaderSrc from '../../assets/images/slds_spinner_brand.gif'

const Loader = ({ fullPage, ...rest }) => {
  return (
    <S.LoaderWrapper fullPage={fullPage} {...rest}>
      <img src={loaderSrc} alt="loader" />
    </S.LoaderWrapper>
  )
}

Loader.propTypes = {
  fullPage: PropTypes.bool,
}

export default Loader
